import { useState } from 'react';
import { Link } from 'react-router-dom';
import { projectList } from '@/mocks/projects';

const PortfolioSection = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const filters = ['All', 'Web', 'Mobile', 'Branding', 'Enterprise'];

  const filteredProjects = activeFilter === 'All'
    ? projectList
    : projectList.filter(p => p.category === activeFilter);

  return (
    <section id="portfolio" className="relative w-full bg-background-50 border-t border-background-200 py-14 md:py-16">
      <div className="section-padding">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10 md:mb-14">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="inline-flex w-6 h-6 items-center justify-center bg-foreground-900 text-background-50 rounded-sm">
                  <i className="ri-briefcase-line text-xs"></i>
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-foreground-600">
                  05 / Portfolio
                </span>
              </div>
              <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-[1.02] tracking-tight text-foreground-900">
                Our Latest{' '}
                <span className="block text-primary-500">Projects.</span>
              </h2>
            </div>

            <div className="flex flex-wrap gap-2">
              {filters.map((filter) => (
                <button
                  key={filter}
                  onClick={() => setActiveFilter(filter)}
                  className={`px-4 py-2 rounded-full text-sm font-mono uppercase tracking-widest border transition-all cursor-pointer whitespace-nowrap ${
                    activeFilter === filter
                      ? 'bg-foreground-900 text-background-50 border-foreground-900'
                      : 'bg-background-50 text-foreground-700 border-background-300 hover:border-foreground-900'
                  }`}
                >
                  {filter}
                </button>
              ))}
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProjects.map((project) => (
              <article
                key={project.slug}
                className="group bg-background-100 border border-background-200 rounded-2xl overflow-hidden flex flex-col hover:bg-background-50 hover:border-foreground-900/30 transition-all"
              >
                <div className="relative h-52 overflow-hidden">
                  <img
                    alt={project.title}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-700"
                    src={project.image}
                  />
                  <span className="absolute top-4 left-4 inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-900 text-[10px] font-mono uppercase tracking-widest">
                    <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                    {project.category}
                  </span>
                  <button
                    className="absolute top-4 right-4 w-9 h-9 flex items-center justify-center rounded-full bg-background-50/95 backdrop-blur-sm border border-background-200 hover:border-foreground-900 transition-colors cursor-pointer"
                    aria-label="Bookmark"
                  >
                    <i className="ri-bookmark-line text-base text-foreground-700"></i>
                  </button>
                </div>
                <Link to={`/portfolio/${project.slug}`} className="p-6 flex-1 flex flex-col">
                  <div className="font-mono text-[10px] uppercase tracking-widest text-foreground-500 mb-3 flex items-center gap-3">
                    <span>{project.client}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                    <span>{project.date}</span>
                  </div>
                  <h4 className="font-display text-xl font-bold text-foreground-900 leading-snug mb-3 group-hover:text-primary-500 transition-colors">
                    {project.title}
                  </h4>
                  <p className="text-sm text-foreground-600 leading-relaxed flex-1">
                    {project.description}
                  </p>
                  <div className="mt-5 pt-5 border-t border-background-200 flex items-center justify-between">
                    <button className="inline-flex items-center gap-2 text-sm cursor-pointer group/like" aria-label="Like" onClick={(e) => e.preventDefault()}>
                      <span className="w-8 h-8 flex items-center justify-center rounded-full transition-all bg-background-100 text-foreground-600 group-hover/like:bg-primary-500/10 group-hover/like:text-primary-500">
                        <i className="ri-heart-line text-base"></i>
                      </span>
                      <span className="font-mono text-xs tabular-nums text-foreground-700">{248 + projectList.indexOf(project) * 42}</span>
                    </button>
                    <span className="inline-flex items-center gap-2 text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors cursor-pointer">
                      View <i className="ri-arrow-right-up-line text-base"></i>
                    </span>
                  </div>
                </Link>
              </article>
            ))}
          </div>

          <div className="mt-10 flex justify-center">
            <Link
              to="/portfolio"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 border border-background-300 hover:border-foreground-900 text-sm font-semibold text-foreground-900 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-add-line text-base"></i>
              View All Projects
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;